module.exports = __webpack_public_path__ + "static/img/bg.2d941f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contest/bg.png
// module id = 9gIX
// module chunks = 1